import { gcpURL } from './utils';

const mockUserPic1 = `${gcpURL}/static/17_bambi_2.png`;
const mockUserPic2 = `${gcpURL}/static/17_mockUser_2.png`;
const mockBiggestImg = `${gcpURL}/static/ig-pentagon-1@2x.png`;

const mockData = {
  awards: [
    {
      title: '直播內容',
      list: [
        {
          awardTitle: '最佳直播歌唱獎',
        },
        {
          awardTitle: '最佳直播舞蹈獎',
        },
        {
          awardTitle: '最佳直播美食獎',
          hasWinner: true,
          winner: '斑比 / bambi',
          winnerPic: mockUserPic1,
        },
        {
          awardTitle: '最佳直播體能獎',
          hasWinner: true,
          winner: '小亞',
          winnerPic: mockUserPic2,
        },
        {
          awardTitle: '最佳直播綜藝獎',
        },
        {
          awardTitle: '最佳直播美妝獎',
        },
      ],
    },
    {
      title: '年度個人',
      list: [
        {
          awardTitle: '年度直播全勤獎',
          info: '2017 年的每一天不論晴雨全年無休的獨一無二全勤主播！',
          hasWinner: true,
          winner: '斑比 / bambi',
          winnerPic: mockUserPic1,
        },
        {
          awardTitle: '年度風雲人物獎',
          info: '24 小時內累計史上最高禮物數的風雲主播',
        },
        {
          awardTitle: '年度最佳長播獎',
          info: '在眾主播中脫穎而出直播時數最長的冠軍主播',
        },
        {
          awardTitle: '年度新人獎',
          info: '表現優異直播新人',
          isNoWrap: true,
        },
        {
          awardTitle: '17 特殊貢獻獎',
          info: '自 17 開創以來，始終與 17 在一起的義氣相挺主播。',
          isLong: true,
          nominee: '小亞',
        },
        {
          awardTitle: '17 之星獎',
          info: '綜合五項指標分數；總時數、追蹤數、分享數、開播週數及收禮週數，嚴格評選出最全方位的 17 之星。',
          isLong: true,
          isNoWrap: true,
          isBiggest: true,
          subTitle: '17 之星入圍的有',
          nominees: [
            { img: mockBiggestImg, name: '小雪' },
            { img: mockBiggestImg, name: '小雪' },
            { img: mockBiggestImg, name: '小雪' },
          ],
        },
      ],
    },
    {
      title: '年度組織',
      list: [
        {
          awardTitle: '年度風雲義氣幫',
          info: '2017 年度『百萬幫派大作戰』獲得義氣幫派前五名者。',
          isLong: true,
          isMulti: true,
        },
        {
          awardTitle: '年度風雲豪氣幫',
          info: '2017 年度『百萬幫派大作戰』獲得豪氣幫派前五名者。',
          isLong: true,
          isMulti: true,
        },
        {
          awardTitle: '年度風雲霸氣幫',
          info: '2017 年度『百萬幫派大作戰』獲得霸氣幫派前三名者。',
          isLong: true,
          isMulti: true,
          hasWinner: true,
          winners: [
            { img: mockUserPic1, name: '斑比 / bambi' },
            { img: mockUserPic2, name: '小亞' },
          ],
        },
        {
          awardTitle: '年度十大主萌主',
          info: '2017 年幫派萌主爭霸賽前十名勝出主播',
          isLong: true,
          isMulti: true,
          hasWinner: true,
          winners: [
            { img: mockUserPic1, name: '斑比 / bambi' },
            { img: mockUserPic2, name: '小亞' },
            { img: mockUserPic1, name: '斑比 / bambi' },
            { img: mockUserPic2, name: '小亞' },
            { img: mockUserPic1, name: '斑比 / bambi' },
          ],
        },
      ],
    },
    {
      title: '個人風格',
      list: [
        {
          awardTitle: '最佳口才主播獎',
        },
        {
          awardTitle: '最佳造型主播獎',
        },
        {
          awardTitle: '校園人氣主播獎',
        },
        {
          awardTitle: '最佳人氣男主播獎',
        },
        {
          awardTitle: '最佳人氣女主播獎',
        },
        {
          awardTitle: '最佳魅力主播獎',
        },
        {
          awardTitle: '最佳幽默主播獎',
        },
      ],
    },
  ],
};


export default () => {
  const timestamp = new Date().getTime();
  let url = 'https://assets.17app.co/golden_feather/result/award.json';

  if(process.env.NODE_ENV === "development") {
    return Promise.resolve(require('./award'));
  }

  const urlWithTimestamp = `${url}?t=${timestamp}`;

  return fetch(urlWithTimestamp)
    .then(response => response.json())
    .catch(err => console.error(err));
};



// WEBPACK FOOTER //
// ./src/lib/loadJSON.js